import script from "./CreatorAssignMemberTagModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatorAssignMemberTagModal.vue?vue&type=script&setup=true&lang=js"

import "./CreatorAssignMemberTagModal.vue?vue&type=style&index=0&id=feca72c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-feca72c0"]])

export default __exports__